// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3ndvF","list":"PatternAutocomplete_list__26AIL"};